import {techStack} from "../../portfolio";

export default function StackProgress() {
  // The old percentage bars are intentionally removed from the visual design.
  // Keep this component for backwards compatibility with the original template.
  if (!techStack.viewSkillBars) return null;
  return null;
}
